// Monday-first weekday labels, shared by the rotation grid headers and the CSV
// column layout so the two never drift.
export const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
